<form
  class="group"
  [class.group--glass]="variant() === 'glass'"
  (submit)="onSubmit($event)"
>
  <input
    type="text"
    class="chat-text"
    name="chatInput"
    [placeholder]="placeholder()"
    [value]="text()"
    (input)="text.set($any($event.target).value)"
  />
  <button type="submit" class="send" [class.armed]="armed()" aria-label="Send">
    <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/></svg>
  </button>
</form>
